import React from "react"
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import classNames from "classnames"
import { ProcessLink } from "../../../global/helpers"

const ColumnItem = ({ blok }) => { 
  const link = (typeof blok.link !== 'undefined') ? ProcessLink(blok.link) : false;
  const Columns = ({blok}) => (
    <>
      {blok.column_content &&
        blok.column_content.map(blok => (
          <StoryblokComponent key={blok._uid} blok={blok} />
        ))}
    </>
  ) 
  return(
    <div
      className={classNames("gs_reveal", "column_item", {
        [blok.column_style]: blok.column_style && blok.column_style !== "none",
      }, (link && link.url) ? 'linked' : '')}
      style={{ 
        "--width": (blok.column_width !== "0") ? blok.column_width + '%' : 'auto',
        "--m-width": blok.column_width_mobile
        ? ((blok.column_width_mobile !== "0") ? blok.column_width_mobile + '%' : 'auto')
        : "100%",
      }}
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      {(link && link.url) ?
        <a href={link.url}  target={link.target} aria-label="Column Link" className={link.cssClass}>
          <Columns blok={blok} />
        </a>
      :
        <Columns blok={blok} />
      }
    </div>
  )
}
export default ColumnItem
